import React, { Component } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styles = theme => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginBottom: theme.spacing(0.25),
    height: 26,
  },
});

class MultiSelectInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.default,
    };
  }

  render() {
    const {
      input,
      label,
      meta: { touched, error },
      children,
      classes,
      ...custom
    } = this.props;

    return (
      <FormControl required={custom.required} fullWidth={custom.fullWidth}>
        <InputLabel htmlFor={custom.name}>{label}</InputLabel>
        <Select
          {...input}
          multiple
          value={this.state.value}
          onChange={(event, index, value) => {
            this.setState({ value: event.target.value });
            input.onChange(event.target.value);
          }}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(value => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
          {...custom}
        >
          {children}
        </Select>
        {touched && error && (
          <FormHelperText error id={`${custom.name}-error`}>
            {error}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
}

export default withStyles(styles)(MultiSelectInput);
